<template>
  <growth-contact-button
    v-track="'course_download_program_clicked'"
    :block="block"
    :color="color"
    :confirmation-toast="false"
    data-cy-download-program-cta
    :icon="icon"
    :origin="origin"
    :origin_page_action="origin_page_action"
    :origin_page_id="course.slug"
    :redirect="redirect"
    :size="size"
    skip-form-if-known-user
    :variant="variant"
    @skipped="download"
  >
    <slot>
      {{ $t("course.page.program_download_cta") }}
    </slot>
  </growth-contact-button>
</template>

<script lang="ts" setup>
import type { ButtonProps } from "@pollen/ui-library";

import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";
import type { ContactFlowMetadata } from "~~/model/analytics.model";

const properties = defineProps<
  ButtonProps & {
    origin: ContactFlowMetadata["origin"];
    course: Parameters<typeof useCoursePageProgramDownload>[0] & {
      has_program?: boolean;
    };
    session?: CourseSessionView;
  }
>();

const { download } = useCoursePageProgramDownload(properties.course);

const route = useRoute();

const redirect = computed(() => `${route.path}?download_program=true`);

const origin_page_action = computed(() =>
  properties.course.has_program
    ? "download_program_cta"
    : "follow_up_program_cta",
);
</script>
